import { GeneralThemeFormValues } from 'components/Theme/GeneralSettings/generalTheme.types';

import { defaultStoreSettings } from './StoreSettings.consts';
import { IQuantityFormat, IStoreSettingsFormValues } from './StoreSettings.types';

const buildQuantityFormat = (
  source: Partial<IQuantityFormat> | undefined,
  fallback: IQuantityFormat
): IQuantityFormat => ({
  milSeparator: source?.milSeparator || fallback.milSeparator,
  fractionalSeparator: source?.fractionalSeparator || fallback.fractionalSeparator,
  thousandShorthand: source?.thousandShorthand ?? fallback.thousandShorthand,
  millionShorthand: source?.millionShorthand ?? fallback.millionShorthand,
  billionShorthand: source?.billionShorthand ?? fallback.billionShorthand,
  trillionShorthand: source?.trillionShorthand ?? fallback.trillionShorthand,
  quadrillionShorthand:
    source?.quadrillionShorthand ?? fallback.quadrillionShorthand,
  quintillionShorthand:
    source?.quintillionShorthand ?? fallback.quintillionShorthand,
  sextillionShorthand:
    source?.sextillionShorthand ?? fallback.sextillionShorthand,
  septillionShorthand:
    source?.septillionShorthand ?? fallback.septillionShorthand,
  digitsBasedAbbreviation:
    source?.digitsBasedAbbreviation ?? fallback.digitsBasedAbbreviation,
  maxDigitsWithoutShorthand:
    source?.maxDigitsWithoutShorthand ?? fallback.maxDigitsWithoutShorthand
});

export const buildStoreSettingsInitialValues = (
  data?: GeneralThemeFormValues
): IStoreSettingsFormValues => ({
  productsQuantityFormat: buildQuantityFormat(
    data?.productsQuantityFormat,
    defaultStoreSettings.productsQuantityFormat
  ),
  balanceQuantityFormat: buildQuantityFormat(
    data?.balanceQuantityFormat,
    defaultStoreSettings.balanceQuantityFormat
  ),
  specialOfferQuantityFormat: buildQuantityFormat(
    data?.specialOfferQuantityFormat,
    defaultStoreSettings.specialOfferQuantityFormat
  ),
  rollingOfferQuantityFormat: buildQuantityFormat(
    data?.rollingOfferQuantityFormat,
    defaultStoreSettings.rollingOfferQuantityFormat
  ),
  progressBarQuantityFormat: buildQuantityFormat(
    data?.progressBarQuantityFormat,
    defaultStoreSettings.progressBarQuantityFormat
  ),
  triggeredPopupQuantityFormat: buildQuantityFormat(
    data?.triggeredPopupQuantityFormat,
    defaultStoreSettings.triggeredPopupQuantityFormat
  )
});

export const applyQuantityFieldChange = (
  setFieldValue: (field: string, value: boolean | string) => void,
  fieldPath: string,
  rawValue: string
): void => {
  if (rawValue === 'true' || rawValue === 'false') {
    setFieldValue(fieldPath, rawValue === 'true');
    return;
  }
  setFieldValue(fieldPath, rawValue);
};
